module.exports = __webpack_public_path__ + "img/NirvanaEntrance2.3fb8f2d2.png";